import { render, staticRenderFns } from "./btnMapMenu.vue?vue&type=template&id=bc622924&"
import script from "./btnMapMenu.vue?vue&type=script&lang=js&"
export * from "./btnMapMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports